<template>
    <div>
        <AppPushNotification ref="notification" :title="notificationModel.title" :text="notificationModel.text"
            :color="notificationModel.color" />
        <div v-show="!pageLoading">
            <div class="row mt-5" style="padding-bottom: 50cap;">
                <!-- Bill Details Section -->
                <div class="col-md-6 col-sm-12 p-3">
                    <h4><i class="fi fi-rr-receipt"></i>{{ $t('billDetail') }}</h4>
                    <div class="order-detail-box" style="z-index: 1080;">
                        <div class="row">
                            <div v-for="(item, index) in billDetails" :key="index"
                                class="col-12 d-flex justify-content-between">
                                <template>
                                    <span>{{ $t(item.label) }}</span>
                                    <span class="text-right">{{ item.value }}</span>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div v-if="receipt.receiptStatus == 'P'"
                        class="order-detail-box text-grey d-flex justify-content-between align-items-center w-100 mt-2">
                        <span> <i class="fi fi-rr-times-hexagon mr-2 h5" /> {{ $t('cancelPayment') }} </span>
                        <CButton :disabled="btnCancelLoading" @click="cancelPayStatus()" color="danger">
                            <CSpinner size="sm" v-if="btnCancelLoading"></CSpinner>
                            {{ $t('cancel') }}
                        </CButton>
                    </div>
                </div>
                <!-- Payment Method Section -->
                <div class="col-md-6 col-sm-12 p-3">
                    <h4>{{ $t('selectPaymentMethod') }}</h4>
                    <div class="order-detail-box text-grey">
                        <i class="fi fi-rr-bank mr-2" />
                        {{ $t('silomPayProDesp') }}
                    </div>
                    <div class="payment-method-box">
                        <div v-for="(method, index) in filteredPaymentMethods" :key="index" class="payment-option">
                            <label class="payment-label" :for="method.id">
                                <div class="payment-info">
                                    <img class="payment-icon" :src="`/img/paymentIcon/${method.icon}`">
                                    {{ $t(method.name) }}
                                </div>
                                <div class="radio-container">
                                    <input type="radio" :id="method.id" v-model="selectedPayment" :value="method.id" />
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" tabindex="-1" id="payment-pending-modal">
                <div class="modal-dialog">
                    <div class="modal-content" style="background-color: unset;">
                        <div class=" p-0" style="background-color: white;overflow: hidden;">
                            <div class="payment-info-header">
                                {{ $t('billDetail') }}
                            </div>
                            <div class="payment-info-modal">
                                <div class="text-center w-100 mt-3">
                                    <div class="order-detail-box" style="z-index: 1080;">
                                        <div class="row pt-2">
                                            <div v-for="(item, index) in billDetails" :key="index"
                                                class="col-12 d-flex justify-content-between mb-2">
                                                <template>
                                                    <span>{{ $t(item.label) }}</span>
                                                    <span class="text-right">{{ item.value }}</span>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center p-4">
                                <!-- QR Payment -->
                                <div v-if="selectedPayment === 'qr'" class="kbank-payment-container">
                                    <iframe style="width: 100%;border: unset;" class="kbank-payment-container"
                                        :src="`/Payment-Gateway/embeddedKBankQr.html?order_id=${order_id}&receiptObjectId=${receiptObjectId}&uid=${uid}&shopObjectId=${shopObjectId}&locale=${locale}&dashboardUrl=${dashboardUrl}&qrUrl=${qrUrl}`">
                                    </iframe>
                                </div>

                                <!-- Credit Card Payment -->
                                <div v-if="selectedPayment === 'credit'" class="kbank-payment-container">
                                    <iframe style="width: 100%; border: unset;" class="kbank-payment-container"
                                        :src="`/Payment-Gateway/embeddedKBank.html?order_id=${receiptObjectId}&amount=${totalAmount}&name=${shopName}&paymentUrl=${silomPaymentUrl}`">
                                    </iframe>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="fixed-bottom">
                <div class="payment-footer">
                    <CButton :disabled="btnCallStaffLoading" class="btn-color-theme" block @click="handlePayment()">
                        <CSpinner size="sm" v-if="btnCallStaffLoading"></CSpinner>
                        {{ $t('checkOut') }} {{ totalAmount }}฿
                    </CButton>
                </div>
            </div>
        </div>
        <div v-show="pageLoading">
            <div class="lds-ripple">
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { CButton } from '@coreui/vue';
import { mapGetters } from 'vuex';
import AppPushNotification from '@/components/AppPushNotification';
import util from '@/util/util';
import signed from '@/util/signed'
import poscrm from '@/services/poscrm';
import payment from '@/services/payment'
import axios from 'axios';


export default {
    components: {
        AppPushNotification
    },
    data() {
        return {
            billDetails: [
                { label: "totalAmount", value: "" },
                { label: "vat", value: "" },
                { label: "serviceCharge", value: "" },
                { label: "orderItem", value: "" },
                { label: "table", value: "" },
                { label: "numberOfGuest", value: "" },
                { label: "orderTime", value: "" }
            ],
            selectedPayment: "cash",
            notificationModel: {
                color: '',
                title: '',
                text: '',
            },
            pageLoading: false,
            order_id: '',
            receiptObjectId: '',
            locale: '',
            dashboardUrl: process.env.VUE_APP_WEB_DASHBOARD_URL,
            silomPaymentUrl: process.env.VUE_APP_PAYMENT_GATEWAY_URL,
            shopName: '',
            btnCallStaffLoading: false,
            kFrameInterval: null,
            receipt: {},
            btnCancelLoading: false,
            orderShopSetting: {},
            isQRSelfCheckOut: false,
            qrUrl : process.env.VUE_APP_WEB_URL,

        };
    },
    computed: {
        ...mapGetters(['shopLineOA']),
        totalAmount() {
            return this.billDetails.find(item => item.label === "totalAmount")?.value || "0.00";
        },
        filteredPaymentMethods() {
            if (!this.isQRSelfCheckOut) {
                return this.paymentMethods.filter(method => method.id === 'cash');
            }
            return this.paymentMethods;
        },
        paymentMethods() {
            return [
                { id: "cash", name: "paymentType0", icon: "cashIcon.webp", bgColor: "#f5f5f5", type: 'cash' },
                { id: "credit", name: "creditCard", icon: "masterCardIcon.webp", iconHeader: "credit_.webp", bgColor: "#f5f5f5", type: 'credit' },
                { id: "qr", name: "QRCode", icon: "qrIcon.webp", iconHeader: "thaiqr_banner.webp", bgColor: "#113566", type: 'qr' }
            ];
        },
        uid() {
            return `${localStorage.getItem('uid')}`;
        },
        shopObjectId() {
            return `${localStorage.getItem('shopObjectId')}`;
        },
        shop() {
            return this.shopLineOA.find(detail => detail.objectId === this.shopObjectId) || {};
        }
    },
    async created() {
        this.receiptObjectId = localStorage.getItem('receiptObjectId') || '';
        this.shopName = localStorage.getItem('shopName') || '';
        this.locale = this.$i18n.locale;
        this.getReceiptTransaction();
        this.createOrder()
        this.getPKey()
        this.getOrderShopSetting()

    },
    beforeDestroy() {
        $('#payment-pending-modal').modal('hide')
        this.removeModalArtifacts()
    },

    methods: {
        async getReceiptTransaction() {
            try {
                const receiptObjectId = localStorage.getItem('receiptObjectId');
                const uid = localStorage.getItem('uid');
                const res = await poscrm.get(`/api/v1.1/${uid}/Receipt/data/${receiptObjectId}`);

                const receipt = res.data?.data?.document;
                if (!receipt) return;
                this.receipt = receipt

                const activeItems = (receipt.receiptItems || []).filter(item => !item.deleted_at);

                const rawDetails = [
                    { label: "totalAmount", value: +receipt.grandTotal || 0 },
                    { label: "serviceCharge", value: +receipt.serviceCharge || 0 },
                    { label: "vat", value: +receipt.vatAmount || 0 },
                    { label: "orderItem", value: `${activeItems.length} ${this.$t('item')}` },
                    { label: "table", value: receipt.tableName || "-" },
                    { label: "numberOfGuest", value: `${receipt.numCust || 1} ${this.$t('guest')}` },
                    { label: "orderTime", value: receipt.created_at ? moment(receipt.created_at).format('DD/MM/YYYY, HH:mm:ss') : "-" }
                ];

                this.billDetails = rawDetails.filter(item => {
                    return typeof item.value !== 'number' || item.value > 0;
                }).map(item => ({
                    ...item,
                    value: typeof item.value === 'number' ? item.value.toFixed(2) : item.value
                }));
            } catch (error) {
                console.error('Error fetching receipt:', error);
            }
        },
        async createOrder() {
            const orderData = {
                amount: parseFloat(this.totalAmount).toFixed(2),
                currency: 'THB',
                description: "",
                source_type: 'qr',
                reference_order: this.receiptObjectId,
                ref_1: this.uid,
                ref_2: this.shopObjectId
            };
            try {
                const response = await axios.post(
                    `${process.env.VUE_APP_PAYMENT_GATEWAY_URL}/embedded/v1.0/kbank/order`,
                    orderData
                );
                if (response.data?.data?.id) {
                    this.order_id = response.data.data.id;
                } else {
                    throw new Error(response.data?.error?.message || 'Unexpected response format');
                }
            } catch (error) {
                console.error('Error creating order:', error);
            }
        },
        async createRequest(message) {
            this.btnCallStaffLoading = true
            let table = JSON.parse(localStorage.getItem('table')) || [];
            let receiptObjectId = localStorage.getItem('receiptObjectId') || '';

            let data = {
                id: "",
                uid: this.uid,
                receiptObjectId: receiptObjectId,
                shop: {
                    id: this.shop.id,
                    objectId: this.shopObjectId,
                    shopName: this.shop.shopName,
                    branchName: this.shop.branchName
                },
                scope: "table",
                scopeData: {
                    id: table.id || table.objectId,
                    objectId: table.objectId
                },
                title: "New Message",
                message: message,
                created_at: moment().toISOString(),
                status: "new",
                action: "alert",
                priority: "low",
                read_at: null,
                expired: null,
                group: "none",
                ref: "none",
                tableLayout: localStorage.getItem('tableLayout') || false,
                isTracking: true
            };
            try {
                const res = await poscrm({
                    url: process.env.VUE_APP_MESSAGE_CALLSTAFF,
                    data: data,
                    method: 'post'
                });
                this.btnCallStaffLoading = false
                this.showNotification(this.$t('payBill'), this.$t('messageSent'), 'success');
            } catch (error) {
                console.error('Error creating request:', error);
            }
        },
        showNotification(title, text, color) {
            this.notificationModel = {
                color: color,
                title: title,
                text: text
            };
            this.$refs.notification.pushNotification();
        },
        handlePayment() {
            switch (this.selectedPayment) {
                case 'cash':
                    this.createRequest('ชำระเงิน')
                    break;
                case 'credit':
                    $('#payment-pending-modal').modal('show')
                    break;
                case 'qr':
                    $('#payment-pending-modal').modal('show')
                    break;
                default:
                    break;
            }
        },
        removeModalArtifacts() {
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
        },
        getPKey() {
            let token = signed.sign()
            payment({
                method: 'get',
                url: "/embedded/v1.1/kbank/config/" + this.uid + "?shopObjectId=" + this.shopObjectId,
                headers: {
                    authorization: token,
                },
            }).then((res) => {
                localStorage.setItem("pkey", res.data.data.pkey)
                localStorage.setItem("mid", res.data.data.mid)
                return res.data.data.pkey
            })
        },
        async cancelPayStatus() {
            this.btnCancelLoading = true
            let data = {
                receiptObjectId: this.receipt.objectId
            }
            try {
                await poscrm({
                    url: '/api/v1.1/' + this.uid + '/Receipt/selforder/paymentstatus/cancel',
                    data: data,
                    method: 'post',
                }).then((res) => {
                    this.$router.push('/dine-in/menulists')
                    console.log('Unlocked Payment')
                })
            } catch (error) {
                throw new Error(error)
            } finally {
                this.btnCancelLoading = false
            }
        },
        async getOrderShopSetting() {
            this.pageLoading = true
            const uid = `${localStorage.getItem('uid')}`
            const shopObjectId = `${localStorage.getItem('shopObjectId')}`

            let params = {
                shopObjectId: shopObjectId,
            }
            try {
                await poscrm({
                    method: 'get',
                    url: '/api/v2.1/' + uid + '/OrderShopSetting',
                    params: params,
                }).then((res) => {
                    this.orderShopSetting = res.data?.data?.[0] || null
                    this.isQRSelfCheckOut = this.orderShopSetting?.isQRSelfCheckOut || false

                })
            } catch (error) {
                throw new Error(error)
            } finally {
                this.pageLoading = false
            }
        },
    },
};
</script>

<style scoped>
.kbank-payment-container {
    display: flex;
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 100%;
    left: 0;
}

.modal-body {
    padding: 0rem;
}

.payment-info-modal {
    height: 100vh;
    text-align: right;
    padding: 2cap;
    background: #57C785;
    background: linear-gradient(56deg, rgba(87, 199, 133, 1) 10%, rgba(222, 237, 83, 1) 100%);
}

.payment-info-header {
    background-color: #219b78;
    color: white;
    text-align: center;
    padding: 2.5cap;
    font-size: 20px;
}
</style>
